import React from "react";

function Photographer() {
  return (
    <main>
        <section className="hero">
            <div>
                <h1>Photographers</h1>
                <p>Browse and book professional photographers near you!</p>
            </div>
        </section>
    </main>
    
  );
}

export default Photographer;
